export default __webpack_public_path__ + "index.html?95efe2771bb285c241a867e9ff387446";